module.exports = __webpack_public_path__ + "img/question.54294aed.png";